export default function formatBool (value) {
  if (value === undefined || value == null) { return '' }
  if (value) {
    return 'ja'
  } else {
    return 'nee'
  }
}
